import React from 'react';
import styles from './error-msg.module.scss';
import { Button, Icon, BodyText } from '@placer-ui/components';

export const ErrorMsgText = 'There was a problem.';
export const ErrorTryAgain = 'Please try again.';
type ErrorMsgProps = {
    onClick?: () => void;
};
export const ErrorMsg = ({ onClick }: ErrorMsgProps) => {
    return (
        <div className={styles.container} data-testid="failed-assistant-response">
            <div className={styles.textInfo}>
                <Icon
                    type={'WarningCircle'}
                    weight={'duotone'}
                    color={'warning'}
                    size={24}
                    testId={'icon-warning-circle'}
                />
                <BodyText variant={'semi-bold'}>{`${ErrorMsgText}${
                    onClick ? ` ${ErrorTryAgain}` : ''
                }`}</BodyText>
            </div>
            {onClick && (
                <div className={styles.button}>
                    <Button
                        fullWidth={true}
                        testId={'pi-error-msg-button'}
                        onClick={onClick}
                        variant={'secondary-blue'}
                    >
                        Resubmit
                    </Button>
                </div>
            )}
        </div>
    );
};
